"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var style_1 = require("./style");
var TopSection = function (_a) {
    var left = _a.left, right = _a.right;
    return (react_1.default.createElement(style_1.Wrapper, null,
        react_1.default.createElement("div", { className: 'TopSection__Container' },
            react_1.default.createElement("div", { className: 'TopSection__Left' },
                react_1.default.createElement("span", { className: 'TopSection__Title' }, left.title),
                left.links.map(function (_a, i) {
                    var icon = _a.icon, label = _a.label, props = _a.props;
                    return ((icon !== undefined)
                        ? (react_1.default.createElement("a", __assign({ className: 'TopSection__Link' }, props, { key: i + "-" + icon.name }),
                            react_1.createElement(icon),
                            react_1.default.createElement("span", { className: 'TopSection__LinkLabel' }, label))) : null);
                })),
            react_1.default.createElement("div", { className: 'TopSection__Right' },
                react_1.default.createElement("span", { className: 'TopSection__Title' }, right.title),
                right.links.map(function (_a, i) {
                    var icon = _a.icon, props = _a.props;
                    return ((icon !== undefined)
                        ? (react_1.default.createElement("a", __assign({ className: 'TopSection__Link' }, props, { key: i + "-" + icon.name }), react_1.createElement(icon))) : null);
                })))));
};
exports.default = TopSection;
